/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'number',
      minimum: 0,
      maximum: 100,
    },
    unit: {
      type: 'string',
      enum: ['PERCENTAGE'],
      minLength: 1,
    },
  },
  required: ['value', 'unit'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    prov_approximate_of_wrkrs_who_can_communicate_in_this_language: valueSchema,
  },
}
